var map = {
	"./almalinux.svg": "389b",
	"./anolis.svg": "bc3d",
	"./archlinux.svg": "824e",
	"./centos.svg": "e9a8",
	"./coreos.svg": "36cd",
	"./debian.svg": "686b",
	"./fedora.svg": "4815",
	"./freebsd.svg": "42b1",
	"./gentoo.svg": "d9b0",
	"./kylin.svg": "2f8a",
	"./linux.svg": "d978",
	"./nfs.svg": "0248",
	"./opencloudos.svg": "c6b8",
	"./openeuler.svg": "b471",
	"./redhat.svg": "8514",
	"./rockylinux.svg": "ae03",
	"./suse.svg": "3399",
	"./ubuntu.svg": "8e7d",
	"./unknow.svg": "3141",
	"./virtio.svg": "930b",
	"./windows.svg": "b1b2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f5";